import axiosInstance from 'interceptor/axiosInstance';
import { CommodityList } from 'models/CommodityList/CommodityList.model';
import { useState } from 'react';
import { generatePath } from 'react-router-dom';
import { ApiRoutes } from 'routes/routeConstants/apiRoutes';
import { deserialize } from 'serializr';
import Notification from 'shared/components/Notification';
import { NotificationTypes } from 'enums/notificationTypes';
import { commodityDeletedMessage } from 'constants/constants';

const CommodityListService = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [deleteLoading, setDeleteLoading] = useState<boolean>(false);
  const [commodityListData, setCommodityListData] = useState<CommodityList>();

  const fetchCommodityList = async (params: {
    page?: number;
    size?: number;
    status?: string;
    search?: string;
    locationId?: string;
    year?: string;
  }) => {
    const { page = 1, search, locationId, year, status, size = 10 } = params;
    const queryParams = {
      page,
      search,
      location_id: locationId,
      year,
      status,
      size: size,
    };
    try {
      setLoading(true);
      const response = await axiosInstance.get(ApiRoutes.COMMODITY_LIST, {
        params: queryParams,
      });
      const commodityResponse = deserialize(CommodityList, response.data);
      setCommodityListData(commodityResponse);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const deleteCommodity = async (commodityId?: number, isLivestock?: boolean) => {
    try {
      setDeleteLoading(true);
      await axiosInstance.delete(
        generatePath(isLivestock ? ApiRoutes.GET_LIVE_STOCK_COMMODITY : ApiRoutes.DELETE_COMMODITY, { commodityId })
      );
      Notification({
        message: commodityDeletedMessage,
        description: '',
        type: NotificationTypes.SUCCESS,
      });
    } catch (error) {
    } finally {
      setDeleteLoading(false);
    }
  };

  return {
    loading,
    commodityListData,
    fetchCommodityList,
    deleteCommodity,
    deleteLoading,
  };
};

export default CommodityListService;
